import { render } from "./ModalConfirmCopy.vue?vue&type=template&id=b0237f84&scoped=true"
import script from "./ModalConfirmCopy.vue?vue&type=script&lang=js"
export * from "./ModalConfirmCopy.vue?vue&type=script&lang=js"

import "./ModalConfirmCopy.vue?vue&type=style&index=0&id=b0237f84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0237f84"]])

export default __exports__